import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Stack,
  HStack,
  Button,
  VStack,
  useDisclosure,
  Spinner,
  Checkbox,
  ButtonGroup,
  useToast,
  IconButton,
  Tag,
  Wrap,
  WrapItem,
  InputGroup,
  Input,
  InputRightElement,
  Icon,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteDocs,
  getDocs,
} from '../../stores/slices/resources/docs/docsActions';
import { format, isBefore } from 'date-fns';
import UploadResource from './UploadResource';
import { AiOutlineMenuUnfold } from 'react-icons/ai';
import { motion } from 'framer-motion';
import Folder from './Folder';
import CurrentFolder from './CurrentFolder';
import DeleteAlert from '../Alerts/DeleteAlert';
import { securedAxiosInstance } from '../../api/axios';
import chroma from 'chroma-js';
import Search from '../icons/Search';
import SearchResource from './SearchResource';

const Files = () => {
  const [selectedDocs, setSelectedDocs] = useState([]);
  const { activeFolder } = useSelector(state => state.folders);
  const [toUpdate, setToUpdate] = useState({ state: false, doc: null });
  const { docs, loading } = useSelector(state => state.docs);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlertAlert,
    onClose: onCloseAlert,
  } = useDisclosure();
  const {
    getButtonProps,
    getDisclosureProps,
    isOpen: isOpenDrawer,
  } = useDisclosure();
  const [hidden, setHidden] = useState(!isOpenDrawer);

  const [isDeleting, setIsDeleting] = useState(false);
  const cancelRef = useRef();
  const toast = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDocs({ id: activeFolder.id }));
  }, [activeFolder]);
  const handleSelectAll = event => {
    let newSelectedDocs;

    if (event.target.checked) {
      newSelectedDocs = docs.map(doc => doc.id);
    } else {
      newSelectedDocs = [];
    }

    setSelectedDocs(newSelectedDocs);
  };
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedDocs.indexOf(id);
    let newSelectedDocs = [];

    if (selectedIndex === -1) {
      newSelectedDocs = newSelectedDocs.concat(selectedDocs, id);
    } else if (selectedIndex === 0) {
      newSelectedDocs = newSelectedDocs.concat(selectedDocs.slice(1));
    } else if (selectedIndex === selectedDocs.length - 1) {
      newSelectedDocs = newSelectedDocs.concat(selectedDocs.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedDocs = newSelectedDocs.concat(
        selectedDocs.slice(0, selectedIndex),
        selectedDocs.slice(selectedIndex + 1)
      );
    }

    setSelectedDocs(newSelectedDocs);
  };

  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, doc: null });
  };
  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(deleteDocs({ selectedDocs }));
    await dispatch(getDocs({ id: activeFolder.id }));
    onCloseAlert();
    setIsDeleting(false);
    if (res.type === 'docs/deleteDocs/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      setSelectedDocs([]);
      toast({
        description: 'Item has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };

  const downloadResource = async (name, id, ext) => {
    const res = await securedAxiosInstance.get(`resources/${id}/download`, {
      responseType: 'blob',
    });

    let blob = new Blob([res.data], { type: res.headers.content_type });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = name + '.' + ext;
    link.click();
  };

  const isRead = (openedAt, updatedAt) => {
    return isBefore(new Date(openedAt), new Date(updatedAt));
  };
  return (
    <React.Fragment>
      <Box
        as={motion.div}
        minW={'200px'}
        overflow="hidden"
        {...getDisclosureProps()}
        hidden={hidden}
        initial={false}
        onAnimationStart={() => setHidden(false)}
        onAnimationComplete={() => setHidden(!isOpenDrawer)}
        animate={{ display: isOpenDrawer ? 'unset' : 'none' }}
      >
        <Folder h={'full'} />
      </Box>
      <Box
        w={{ base: '100%', xl: '90%' }}
        overflowX={'hidden'}
        overflowY={'auto'}
      >
        <VStack spacing={'4'}>
          <VStack
            alignItems={'start'}
            w={'full'}
            pb={'2'}
            zIndex={'10'}
            pl={{ base: isOpenDrawer ? 4 : 0, xl: 0 }}
            sx={{
              position: '-webkit-sticky',
              /* Safari */
              position: 'sticky',
              top: '0',
            }}
            bg={'white'}
            borderBottom={'1px'}
            borderColor={'gray.500'}
          >
            <Stack
              justifyContent={'space-between'}
              alignContent={'center'}
              direction={{ base: 'column', sm: 'row' }}
              w={'full'}
              spacing={4}
              pr={'2'}
            >
              <HStack w={'full'}>
                <IconButton
                  aria-label="Menu"
                  display={{
                    base: 'inline-flex',
                    xl: 'none',
                  }}
                  icon={<AiOutlineMenuUnfold />}
                  variant={'outline'}
                  size="xs"
                  {...getButtonProps()}
                />
                <Heading as={'h4'} size="md">
                  Files
                </Heading>
                <SearchResource />
              </HStack>
              <HStack spacing={2}>
                <Button size={'sm'} onClick={onOpen}>
                  Upload
                </Button>
                <Button
                  size={'sm'}
                  disabled={selectedDocs.length <= 0}
                  bg={'red.400'}
                  _hover={{
                    color: 'red.400',
                    bg: 'transparent',
                  }}
                  onClick={onOpenAlertAlert}
                >
                  Delete
                </Button>
              </HStack>
            </Stack>
            <CurrentFolder />
          </VStack>
          {/* <Box w={'full'} overflowX={'auto'} overflowY={'auto'} h={'full'}> */}
          <Box overflowX={'auto'} w={'full'}>
            <TableContainer>
              <Table
                variant="striped"
                colorScheme="gray"
                display={{
                  base: 'block',
                  md: 'table',
                }}
              >
                <Thead>
                  <Tr>
                    <Th>
                      <Checkbox
                        value="true"
                        onChange={handleSelectAll}
                        isChecked={selectedDocs.length === docs.length}
                      />
                    </Th>
                    <Th>Name</Th>
                    <Th>Published By</Th>
                    <Th>Published Date</Th>
                    <Th>Tags</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {docs &&
                    (loading ? (
                      <Tr>
                        <Td colSpan={'6'}>
                          <Spinner color="primary" />
                        </Td>
                      </Tr>
                    ) : docs.length > 0 ? (
                      docs.map(doc => (
                        <Tr
                          key={doc.id}
                          fontWeight={
                            isRead(doc.opened_at, doc.updated_at)
                              ? 'bold'
                              : 'normal'
                          }
                        >
                          <Td>
                            <Checkbox
                              value="true"
                              isChecked={selectedDocs.indexOf(doc.id) !== -1}
                              onChange={event => handleSelectOne(event, doc.id)}
                            />
                          </Td>
                          <Td>{doc.name}</Td>
                          <Td>{doc.author && doc.author.full_name ? doc.author.full_name : ""}</Td>
                          <Td>
                            {format(new Date(doc.created_at), 'd MMM h:mm a')}
                          </Td>
                          <Td px={'1'}>
                            <Wrap w={'150px'}>
                              {doc.resource_tags.map(tag => (
                                <WrapItem key={tag.id}>
                                  <Tag
                                    size={'sm'}
                                    key={tag.id}
                                    variant="solid"
                                    bg={tag.colour}
                                    // color={
                                    //   chroma.contrast(tag.colour, 'white') > 2
                                    //     ? 'white'
                                    //     : 'black'
                                    // }
                                  >
                                    {tag.name}
                                  </Tag>
                                </WrapItem>
                              ))}
                            </Wrap>
                          </Td>
                          <Td>
                            <ButtonGroup size="sm" isAttached>
                              <Button
                                onClick={() => {
                                  setToUpdate({
                                    state: true,
                                    doc,
                                  });
                                  onOpen();
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                onClick={() => {
                                  downloadResource(
                                    doc.name,
                                    doc.id,
                                    doc.extension
                                  );
                                }}
                              >
                                Download
                              </Button>
                            </ButtonGroup>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={'6'}>No files found</Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
            {/* </Box> */}
          </Box>
        </VStack>
      </Box>

      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Delete Resource${selectedDocs.length > 1 ? 's' : ''}`}
        body={
          "Are you sure? If you proceed with the deletion, it'll be gone forever."
        }
        onDeleteItem={onDeleteItem}
      />

      {isOpen && (
        <UploadResource
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default Files;
